import { useRecordContext } from 'react-admin';
import { User } from '../graphql/types';

export const UserTitle = () => {
  const record = useRecordContext<User>();
  return <span>User: {record ? `${record.email}` : ''}</span>;
};
